import React from "react";

import styles from "./TextInputCell.module.scss";

type TextInputCellProps = {
  name?: string;
  value?: string;
  width?: string;
  height?: string;
  placeholder?: string;
  disabled?: boolean;
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const TextInputCell: React.FC<TextInputCellProps> = ({
  name,
  value,
  placeholder,
  width = "100%",
  height = "100%",
  disabled,
  handleChange,
}) => {
  return (
    <input
      className={styles.textInputCell}
      style={{ width, height }}
      name={name}
      type="text"
      value={value}
      placeholder={placeholder ? placeholder : "テキストを入力してください。"}
      disabled={disabled}
      onChange={e => handleChange && handleChange(e)}
    />
  );
};

export default TextInputCell;
